//React
import React from 'react';

//pages
import { ProvidersManagement } from 'pages/providers';

//hooks
import { useAdminProviderManagementData } from './useAdminProviderManagementData';

export const AdminProvidersManagement: React.FC = () => {
  const {
    providers,
    payors,
    roles,
    currentSite,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchProviders,
    setIsLoading,
  } = useAdminProviderManagementData();
  return (
    <ProvidersManagement
      providers={providers}
      payors={payors}
      roles={roles}
      currentSite={currentSite}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
      refetchProviders={refetchProviders}
      setIsLoading={setIsLoading}
    />
  );
};
